import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9ed17c48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "questionsView" }

import { onMounted, ref, watchEffect } from "vue";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import moment from "moment";
import { QuestionControllerService } from "../../../generated/services/QuestionControllerService";
import { Question } from "../../../generated/models/Question";


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionsView',
  setup(__props) {

document.title = "题库";

const router = useRouter();

// 搜索参数
const searchParams = ref({
  title: "",
  difficulty: undefined,
  tags: [],
  pageSize: 10,
  current: 1,
});

// 题目总数
const total = ref(0);

// 题目数据
const dataList = ref([]);

/**
 * 获取题目数据
 */
const loadData = async () => {
  const res = await QuestionControllerService.listQuestionVoByPageUsingPost({
    ...searchParams.value,
  });
  if (res.code === 0) {
    dataList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error("加载失败，" + res.message);
  }
};

/**
 * 监听loadData函数所使用的变量的变化，改变时触发页面的重新加载
 */
watchEffect(() => {
  loadData();
});

onMounted(() => {
  loadData();
});

const columns = [
  {
    title: "状态",
    slotName: "isAccepted",
    align: "center",
  },
  {
    title: "题目",
    slotName: "title",
    align: "center",
  },
  {
    title: "难度",
    slotName: "difficulty",
    align: "center",
  },
  {
    title: "标签",
    slotName: "tags",
    align: "center",
  },
  {
    title: "通过率",
    slotName: "acceptedRate",
    align: "center",
  },
];
/**
 * 跳转到做题页面
 * @param question
 */
const toDoQuestion = (question: Question) => {
  router.push({
    path: `/view/question/${question.id}`,
  });
};

/**
 * 页面切换
 * @param page
 */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};

/**
 * 页面大小切换
 * @param size
 */
const onPageSizeChange = (size: number) => {
  searchParams.value = {
    ...searchParams.value,
    pageSize: size,
  };
};

/**
 * 搜索函数
 */
const doSearch = () => {
  searchParams.value = {
    ...searchParams.value,
    current: 1,
  };
  // loadData();
};

return (_ctx: any,_cache: any) => {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_tag = _resolveComponent("a-input-tag")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_icon_check_circle = _resolveComponent("icon-check-circle")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, {
      model: searchParams.value,
      layout: "inline",
      style: {"justify-content":"center","align-content":"center","margin":"25px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, { field: "title" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_search, {
              modelValue: searchParams.value.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.title) = $event)),
              placeholder: "搜索题目",
              style: {"min-width":"220px","border-radius":"10px"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { field: "difficulty" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              style: {"width":"220px","border-radius":"10px"},
              modelValue: searchParams.value.difficulty,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.value.difficulty) = $event)),
              "allow-clear": "",
              placeholder: "选择难度"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_option, { value: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_typography_text, { type: "success" }, {
                      default: _withCtx(() => [
                        _createTextVNode("简单")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_option, { value: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_typography_text, { type: "warning" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 中等")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_option, { value: 2 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_typography_text, { type: "danger" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 困难")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { field: "tags" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_tag, {
              modelValue: searchParams.value.tags,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchParams.value.tags) = $event)),
              placeholder: "输入标签",
              style: {"min-width":"220px","border-radius":"10px"},
              "max-tag-count": "3"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_a_divider, { size: "0" }),
    _createVNode(_component_a_table, {
      columns: columns,
      data: dataList.value,
      pagination: {
        showTotal: true,
        current: searchParams.value.current,
        pageSize: searchParams.value.pageSize,
        total: total.value,
        showPageSize: true,
      },
      onPageChange: onPageChange,
      onPageSizeChange: onPageSizeChange
    }, {
      isAccepted: _withCtx(({ record }) => [
        (record.isAccepted == 0)
          ? (_openBlock(), _createBlock(_component_a_tooltip, {
              key: 0,
              content: "已解答"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_icon_check_circle, {
                  style: { fontSize: '32px', color: 'green' },
                  "stroke-width": 2
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      title: _withCtx(({ record }) => [
        _createVNode(_component_a_button, {
          type: "text",
          onClick: ($event: any) => (toDoQuestion(record))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(record.title), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      difficulty: _withCtx(({ record }) => [
        _createVNode(_component_a_space, { wrap: "" }, {
          default: _withCtx(() => [
            (record.difficulty == 0)
              ? (_openBlock(), _createBlock(_component_a_typography_text, {
                  key: 0,
                  type: "success"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 简单 ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (record.difficulty == 1)
              ? (_openBlock(), _createBlock(_component_a_typography_text, {
                  key: 1,
                  type: "warning"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 中等 ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (record.difficulty == 2)
              ? (_openBlock(), _createBlock(_component_a_typography_text, {
                  key: 2,
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 困难 ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024)
      ]),
      tags: _withCtx(({ record }) => [
        _createVNode(_component_a_space, { wrap: "" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.tags, (tag, index) => {
              return (_openBlock(), _createBlock(_component_a_tag, {
                key: index,
                color: "gray",
                style: {"border-radius":"10px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tag), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 2
        }, 1024)
      ]),
      acceptedRate: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(`${
            record.submitNum != 0
              ? (record.acceptedNum / record.submitNum).toFixed(2) * 100
              : "0"
          }%(${record.acceptedNum}/${record.submitNum})`), 1)
      ]),
      _: 1
    }, 8, ["data", "pagination"])
  ]))
}
}

})